import { useEffect } from 'react';
import { useCrmIntegration } from '../../crm-integration/hooks/use-crm-integration';
import {
  customerIntelligenceFiltersStore,
  INSIGHTS_PAGE_KEY,
  reducers,
} from '../stores/customer-intelligence-filters';
import { hasCurrentView } from '../../saved-filters/has-current-view';
import { getCurrentView } from '../../saved-filters/get-current-view';

const {
  accountsSelected,
  categoryChanged,
  contractValuesChanged,
  contractRenewalDateBeforeChanged,
  dateTypeOptionChanged,
  dateRangeChanged,
  groupSelected,
  memberSelectionToggled,
  allMembersToggled,
  meetingsImInvitedOnlyToggled,
  filtersReset,
  setCrmMap,
  saveFilterView,
  setCurrentFilterView,
  participantsChanged
} = reducers;

export const useCustomerIntelligenceFilters = () => {
  const {
    accounts,
    category,
    contractRenewalDateBefore,
    contractValueMax,
    contractValueMin,
    dateTypeOption,
    dateRange,
    group,
    industries,
    lifecycleStages,
    meetingsImInvitedOnly,
    members,
    priorities,
    subGroup,
    crmFilters,
    participants,
  } = customerIntelligenceFiltersStore();

  const { workspaceCrmIntegration } = useCrmIntegration();

  const saveFiltersViewWrapper = (viewName: string) => {
    saveFilterView(viewName, workspaceCrmIntegration?.workspace.properties || []);
  }

  useEffect(() => {
    if (hasCurrentView(INSIGHTS_PAGE_KEY)) {
      setCurrentFilterView(getCurrentView(INSIGHTS_PAGE_KEY));
    }
  }, [])

  return {
    accounts,
    category,
    contractRenewalDateBefore,
    contractValueMax,
    contractValueMin,
    dateTypeOption,
    dateRange,
    group,
    industries,
    lifecycleStages,
    meetingsImInvitedOnly,
    members,
    priorities,
    subGroup,
    crmFilters,
    participants,
    setCrmMap,
    changeDateTypeOption: dateTypeOptionChanged,
    toggleAllMembers: allMembersToggled,
    selectAccounts: accountsSelected,
    changeCategory: categoryChanged,
    changeContractValues: contractValuesChanged,
    changeContractRenewalDate: contractRenewalDateBeforeChanged,
    changeDateRange: dateRangeChanged,
    selectGroup: groupSelected,
    toggleMember: memberSelectionToggled,
    toggleMeetingsImInvitedOnly: meetingsImInvitedOnlyToggled,
    resetFilters: filtersReset,
    saveFilterView: saveFiltersViewWrapper,
    setCurrentFilterView,
    participantsChanged,
  };
};
